import React from "react";
import { useParams, Navigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import { CallButtons, Breadcrumbs, LinkChips } from "../components/PageBlocks";
import { articles, findArticle } from "../articles";
import { findVille } from "../villes";
import { servicesSeo } from "../servicesSeo";
import { formatDate } from "./Articles";

export default function ArticlePage() {
  const { slug } = useParams();
  const a = findArticle(slug);
  if (!a) return <Navigate to="/articles" replace />;
  const autres = articles.filter((x) => x.slug !== slug).slice(0, 4);

  return (
    <div data-testid={`article-page-${slug}`}>
      <Header />
      <StickyCall />
      <article>
        <header className="hero-radial py-14 md:py-20">
          <div className="container-narrow max-w-3xl">
            <Breadcrumbs items={[{ to: "/articles", label: "Articles" }, { label: a.category }]} />
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">{a.category} • <time dateTime={a.date}>{formatDate(a.date)}</time> • Par Maître Diamma</p>
            <h1 data-testid="article-h1" className="font-display text-3xl md:text-5xl gold-gradient-text mb-4 leading-tight">{a.title}</h1>
            <div className="gold-divider my-5 max-w-[220px]" />
            <p className="text-gold-soft/95 leading-relaxed text-lg mb-6">{a.description}</p>
            <CallButtons id="article-hero" context={a.title} />
          </div>
        </header>
        <div className="py-14 md:py-16 bg-charcoal">
          <div className="container-narrow max-w-3xl space-y-10">
            {a.sections.map((s) => (
              <section key={s.h2}>
                <h2 className="font-display text-2xl md:text-3xl gold-gradient-text mb-4">{s.h2}</h2>
                <div className="space-y-4">
                  {s.p.map((p) => <p key={p.slice(0, 40)} className="text-gold-soft/95 leading-relaxed">{p}</p>)}
                </div>
              </section>
            ))}
            <div className="card-onyx rounded-xl p-6 md:p-8 gold-border-strong">
              <h2 className="font-display text-xl text-gold mb-2">Parler à Maître Diamma</h2>
              <p className="text-sm text-gold-soft/95 mb-5">Premier contact gratuit, confidentiel, 7j/7 de 8h à 22h.</p>
              <CallButtons id="article-cta" context={a.title} />
            </div>
          </div>
        </div>
      </article>
      <LinkChips testid="article-related" title="Articles liés" links={autres.map((x) => ({ to: `/articles/${x.slug}`, label: x.title }))} />
      <LinkChips testid="article-cities" title="Consulter près de chez vous" links={[...a.villes.map(findVille).map((v) => ({ to: `/marabout/${v.slug}`, label: `Marabout ${v.nom}` })), ...servicesSeo.map((s) => ({ to: `/${s.slug}`, label: s.h1 }))]} />
      <Footer />
    </div>
  );
}
